import { useSyncExternalStore } from "react";

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(callback: () => void): () => void {
  if (typeof window === "undefined" || !window.matchMedia) return () => {};
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

function getSnapshot(): boolean {
  if (typeof window === "undefined" || !window.matchMedia) return false;
  return window.matchMedia(QUERY).matches;
}

/**
 * `true` when the environment requests reduced motion via the
 * `prefers-reduced-motion: reduce` media query — the JS-animation counterpart
 * to the CSS guard already in `theme.css`. Components gate non-CSS animation
 * (e.g. recharts' chart-draw) on this so reduced-motion users get a static
 * render. SSR/jsdom-safe: returns `false` when `matchMedia` is unavailable.
 */
export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
